import { Video, Sparkles } from "lucide-react";

export const Header = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/80 backdrop-blur-xl supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo and Brand */}
          <div className="flex items-center gap-3">
            <div className="relative">
              <img 
                src="https://customer-assets.emergentagent.com/job_client-uploader/artifacts/hzwygg8f_Sticker%20Mule%20Logo2.png"
                alt="AI in Wonderland"
                className="h-10 w-10 object-contain"
              />
            </div>
            <div className="flex flex-col">
              <span className="font-heading text-lg font-semibold text-foreground tracking-tight">
                AI in Wonderland
              </span>
              <span className="text-xs text-muted-foreground font-medium">
                Client Video Upload Portal
              </span>
            </div>
          </div>

          {/* Status Badge */}
          <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-success/10 border border-success/20">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-success"></span>
            </span>
            <span className="text-xs font-medium text-success">Portal Active</span>
          </div>
        </div>
      </div>
    </header>
  );
};
